import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3660e9c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = {
  key: 0,
  class: "custom-icon-container"
}

import { computed, useSlots } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'page-heading',
  props: {
  /**
   * The title or heading associated with the component.
   * @type {string}
   * @required
   */
  title: {
    type: String,
    required: true,
  },
  /**
   * The icon associated with the component.
   * @type {string}
   * @default ''
   */
  icon: {
    type: String,
    default: "",
  },
},
  setup(__props) {



const isCustomIconSlotUsed = computed(() => {
  const slots = useSlots();
  return !!slots["customIcon"];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isCustomIconSlotUsed.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "customIcon")
        ]))
      : _createCommentVNode("", true),
    (__props.icon)
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass(__props.icon)
        }, null, 2))
      : _createCommentVNode("", true),
    _createElementVNode("h2", null, _toDisplayString(__props.title), 1)
  ]))
}
}

})